// Sugalarm — Cycle 109: the header's CGM-status pill (connection dot +
// provider name). Extracted verbatim from KioskHeader's inline pill so
// the mobile compact header renders the identical chip (parity), with the
// kiosk source of truth as the single implementation.
//
// `tone` + dot state are driven by `stale` (green/ok when fresh, amber/
// stale otherwise), exactly as the kiosk did. A null provider falls back
// to "Sugalarm" (the kiosk's no-CGM rendering — not a new state).

import { Pill } from "../ui/Pill";
import { ConnDot } from "./ConnDot";

interface Props {
  provider: string | null;
  stale: boolean;
}

export function ProviderPill({ provider, stale }: Props) {
  return (
    <Pill tone={stale ? "warn" : "ok"}>
      <ConnDot status={stale ? "stale" : "ok"} />
      {provider ? provider[0]!.toUpperCase() + provider.slice(1) : "Sugar Alarm"}
    </Pill>
  );
}
